import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import Select from "react-select";
import TextField from "@mui/material/TextField";
import { FormControlLabel } from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Typography } from "antd";
import { Toaster, toast } from "react-hot-toast";

import axiosNew from "../../store/api/axiosNew";
import hero from "../../Images/hero.jpg";
import { Category, Visibility, VisibilityOff } from "@mui/icons-material";
import { IoCall } from "react-icons/io5";
import "./Signup.css";
import axios from "axios";
import { baseURLNew } from "../../store/api/axiosNew";
import { signupAction_, setUser } from "../../store/action/common/authAction";
import { connect } from "react-redux";
import Tcmodel from "../../components/Tcmodel.jsx";
import Header from "../../components/Header.jsx";
import { ToastContainer } from "react-toastify";
import { IconButton, InputAdornment } from "@mui/material";

const { Title } = Typography;

// const countryOptions = [
//     { label: "India", value: "2" },
// ]

const Finalform = (props) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [region, setRegion] = useState("");
  const [myCountry, setCountry] = useState(null);
  const [state, setState] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [brand, setBrand] = useState("");
  const [websiteURL, setWebsiteURL] = useState("");
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [domainName, setDomainName] = useState(
    sessionStorage.getItem("selectedService") || "",
  );
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [location, setLocation] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const handleClose = () => setShowOtpModal(false);

  const onSignupFinish = (values) => {
    props.signupAction_(values);
  };

  // Handler to toggle state
  const handleClickShowPassword = () => setShowPassword((prev) => !prev);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((prev) => !prev);

  // Handler to prevent default mouse event on icon click (prevents focus loss)
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // useEffect(() => {
  //     const storedCountry = sessionStorage.getItem("selectedSubService");
  //     if (storedCountry) {
  //         const foundCountry = countryOptions.find((c) => c.label === storedCountry);
  //         if (foundCountry) {
  //             setCountry(foundCountry);
  //             fetchStates(foundCountry.value);
  //         }
  //     }
  // }, []);

  // const fetchStates = async (countryId) => {
  //     try {
  //         const response = await fetch(`https://apilead.blaccdot.com/ldsstage/masters/location/country-based-province/${countryId}`);
  //         const data = await response.json();
  //         if (data?.data?.locationmaster) {
  //             const formattedStates = data.data.locationmaster.map((s) => ({
  //                 label: s.locationName,
  //                 value: s.provinceId,
  //             }))
  //             setStateOptions(formattedStates);
  //         }
  //     }
  //     catch (err) {
  //         console.error("Error fetching states:", err);
  //         setStateOptions([]);
  //     }
  // };

  const validateForm = () => {
    const errs = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const contactRegex = /^\d{10}$/;
    // Add this regex inside validateForm
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    if (!password) {
      errs.password = "Password is required";
    } else if (!passwordRegex.test(password)) {
      errs.password =
        "Must be at least 8 characters long and include an uppercase, lowercase, number, and special character";
    }

    if (!confirmPassword) {
      errs.confirmPassword = "Confirm Password is required";
    } else if (password !== confirmPassword) {
      errs.confirmPassword = "Passwords do not match";
    }

    if (!name.trim()) errs.fullName = "Full Name is required";
    if (!email.trim()) errs.email = "Email is required";
    else if (!emailRegex.test(email)) errs.email = "Invalid email format";
    if (!number.trim()) errs.contactNo = "Contact Number is required";
    else if (!contactRegex.test(number))
      errs.contactNo = "Enter 10-digit number";
    // if (!myCountry) errs.country = "Country is required";
    // if (!state || state.length === 0) errs.state = "Select atleast one state";
    if (!brand.trim()) errs.brand = "Brand Name is required";
    if (!agreeToTerms)
      errs.agreeToTerms = "You must agree to Terms & Conditions";
    if (!location.trim()) errs.location = "Location is required";

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    ///
    try {
      // Step 1: Check if user exists / valid
      const checkUserRes = await fetch(
        "https://apilead.blaccdot.com/api/auth/check-user",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email,
            phone: number,
          }),
        },
      );
      const checkUserData = await checkUserRes.json();

      if (!checkUserRes.ok || checkUserData?.success === false) {
        toast.error(checkUserData?.message || "User validation failed");
        return;
      }
      // Save form in sessionStorage or state (optional)
      sessionStorage.setItem("name", name);
      sessionStorage.setItem("email", email);
      sessionStorage.setItem("number", number);
      sessionStorage.setItem("country", myCountry?.label || "");
      sessionStorage.setItem(
        "state",
        JSON.stringify(state?.map((item) => parseInt(item.value, 10)) || []),
      );
      sessionStorage.setItem("brand", brand);
      sessionStorage.setItem("websiteURL", websiteURL);
      sessionStorage.setItem("conuntyid", myCountry?.value || "");

      ////
      // try {
      const otpRes = await fetch(
        "https://euctostaging.com/lms/api/send-otp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phone_number: number }),
        },
      );
      const otpData = await otpRes.json();
      if (otpRes.ok && otpData.success) {
        toast.success("OTP sent");
        setShowOtpModal(true);
      } else {
        toast.error("OTP sending failed");
      }
    } catch (err) {
      toast.error("Error sending OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    const fullOtp = otp.join("");
    if (fullOtp.length !== 6) {
      toast.error("Enter 6-digit OTP");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(
        "https://euctostaging.com/lms/api/verify-otp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phone_number: number, otp: fullOtp }),
        },
      );
      const result = await res.json();
      if (res.ok && result.success) {
        toast.success("OTP Verified");
        setShowOtpModal(false);
        props.signupAction_({
          name,
          email,
          password,
          mobileNo: number,
          // country: myCountry?.label || "",
          // state: state.map((s) => s.value).join(","),
          companyName: brand,
          gmbProfileUrl: websiteURL,
          location,
        });
      } else {
        toast.error("Invalid OTP");
      }
    } catch (err) {
      toast.error("OTP verification failed");
    } finally {
      setLoading(false);
    }
  };

  // const finalSubmit = async () => {
  //     const payload = {
  //         name,
  //         email,
  //         mobileNo: number,
  //         country: myCountry?.label || "",
  //         state: state.map((s) => s.value).join(","),
  //         companyName: brand,
  //         gmbProfileUrl: websiteURL,
  //         location,
  //     };
  //     try {
  //         // const res = await axiosNew.post("/auth/signup", payload);
  //         const res = await axios.post(`${baseURLNew}auth/signup`, payload)
  //         console.log("Signup raw response:", res);
  //         console.log("Signup data:", res.data);
  //         if (res.data?.success) {
  //             localStorage.setItem("accessToken", res.data.tokens.accessToken);
  //             localStorage.setItem("refreshToken", res.data.tokens.refreshToken);

  //             localStorage.setItem("id", res.data.user.id);
  //             localStorage.setItem("name", res.data.user.name);
  //             localStorage.setItem("email", res.data.user.email);
  //             localStorage.setItem("mobileNo", res.data.user.mobileNo);
  //             localStorage.setItem("country", res.data.user.country);
  //             localStorage.setItem("state", JSON.stringify(res.data.user.state));
  //             localStorage.setItem("companyName", res.data.user.companyName);
  //             localStorage.setItem("gmbProfileUrl", res.data.user.gmbProfileUrl);
  //             localStorage.setItem("role", res.data.user.role);
  //             localStorage.setItem("subscriptionSignup", res.data.user.subscriptionSignup);

  //             // props.setUser_({
  //             //     email: res.data.user.email,
  //             //     role: res.data.user.role,
  //             //     name: res.data.user.name,
  //             // });

  //             if (res.data.user.role?.toLowerCase() === "business") {
  //                 navigate("/user-dashboard");
  //             }
  //             else if (res.data.user.role?.toLowerCase() === "admin") {
  //                 navigate('/admin');
  //             }
  //         }
  //         else {
  //             toast.error("Submission failed");
  //         }
  //     }
  //     catch (err) {
  //         toast.error("Form submission error");
  //         console.error(err);
  //     }
  // };
  // useEffect(() => {
  //     console.log(props?.signupResponse, "PROPS RESPONSE")
  //     if (props.signupResponse && props.signupResponse.tokens?.accessToken) {
  //         Promise.resolve().then(() => {
  //             localStorage.setItem("accessToken", props.signupResponse.tokens.accessToken);
  //             localStorage.setItem("refreshToken", props.signupResponse.tokens.refreshToken);
  //             localStorage.setItem("email", props.signupResponse.user.email);
  //             localStorage.setItem("role", props.signupResponse.user.role);
  //             localStorage.setItem("name", props.signupResponse.user.name);
  //             localStorage.setItem("userId", props.signupResponse.user.userId);
  //             localStorage.setItem("id", props.signupResponse.user.id);
  //             localStorage.setItem("phone", props.signupResponse.user.mobileNo);
  //             localStorage.setItem("companyName", props.signupResponse.user.companyName);
  //             localStorage.setItem("country", props.signupResponse.user.country);
  //             localStorage.setItem("domain", props.signupResponse.user.categoryName);
  //             localStorage.setItem("domainid", props.signupResponse.user.category);

  //             props.setUser_({
  //                 email: localStorage.getItem("email"),
  //                 role: localStorage.getItem("role"),
  //                 name: localStorage.getItem("name"),
  //             });
  //         })
  //             .then(() => {
  //                 if (props.signupResponse.user.role?.toLowerCase() === "business") {
  //                     navigate("/user-dashboard");
  //                 } else if (props.signupResponse.user.role?.toLowerCase() === "admin") {
  //                     navigate("/admin");
  //                 }
  //             })
  //     }
  // }, [props.signupResponse])
  useEffect(() => {
    if (props.signupResponse && props.signupResponse.tokens?.accessToken) {
      navigate("/login", {
        state: {
          signupEmail: props.signupResponse.user.email,
          showPasswordHint: true,
        },
      });
    }
  }, [props.signupResponse]);
  useEffect(() => {
    if (props.signupResponse && props.signupResponse.success) {
      toast.success("Signup successful!");
    }
  }, [props.signupResponse]);

  useEffect(() => {
    if (props.signupError && props.signupError.message) {
      console.log("Signup error triggered:", props.signupError);

      if (props.signupError.message.includes("E11000")) {
        toast.error("Email or phone already exists", {
          duration: 19000,
        });
      } else {
        toast.error(props.signupError.message, {
          duration: 19000,
        });
      }
    }
  }, [props.signupError]);

  const handleChangeMain = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    if (value.length > 1) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      nextInput?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        const newOtp = [...otp];
        newOtp[index - 1] = "";
        setOtp(newOtp);
        const prevInput = document.getElementById(`otp-${index - 1}`);
        prevInput?.focus();
      }
      e.preventDefault();
    }
  };
  const handleCheckboxChange = (e) => {
    setAgreeToTerms(e.target.checked);
    const newErrors = { ...errors };
    delete newErrors.agreeToTerms;
    setErrors(newErrors);
  };

  return (
    <>
      <Header />
      <Toaster autoClose={3000} />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "#E6EDF3",
        }}
      >
        <Modal
          show={showOtpModal}
          backdrop="static"
          keyboard={false}
          centered
          contentClassName="verify-modal-content"
        >
          <div className="verify-modal-body">
            <div className="email-icon">
              <IoCall />
            </div>
            <h5 className="title">Verify Your Phone Number</h5>
            <p className="subtitle">
              Please enter the verification code we sent <br />
              to <strong>+91 {number}</strong>{" "}
              <span
                onClick={handleClose}
                style={{
                  textDecoration: "underline",
                  color: "blue",
                  cursor: "pointer",
                }}
              >
                Change Number
              </span>
            </p>

            <div className="otp-inputs">
              {otp.map((digit, i) => (
                <input
                  key={i}
                  id={`otp-${i}`}
                  type="text"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleChangeMain(e, i)}
                  onKeyDown={(e) => handleKeyDown(e, i)}
                  className="otp-box"
                />
              ))}
            </div>
            <Button
              style={{ width: "80%" }}
              variant="contained"
              onClick={handleVerifyOtp}
            >
              Confirm
            </Button>
          </div>
        </Modal>

        <div
          style={{ backgroundColor: "#E6EDF3", height: "85vh", width: "100vw" }}
        >
          <div className="container py-3">
            <div className="formBoxsh">
              <Row>
                <Col md={5} className="FormImages">
                  <img src={hero} alt="Hero" className="hero-image" />
                </Col>
                <Col md={7}>
                  <div className="mainTopic">
                    <h5>One step to get quality leads</h5>
                  </div>
                  <Form onSubmit={handleSubmit} className="signup-form">
                    <Row>
                      {/* <Col md={4}> */}
                      <Col xs={12} md={4} className="form-col">
                        {/* <Form.Group>
                                                <Form.Label>Full Name</Form.Label>
                                                <Form.Control type="text" name="fullname" value={name} onChange={(e) => setName(e.target.value)} isInvalid={!!errors.fullName} />
                                                <Form.Control.Feedback type="invalid">{errors.fullName}</Form.Control.Feedback>
                                            </Form.Group> */}
                        <TextField
                          label="Full Name"
                          value={name}
                          fullWidth
                          onChange={(e) => setName(e.target.value)}
                          error={!!errors.fullName}
                          helperText={errors.fullName}
                        />
                      </Col>
                      {/* <Col md={4}> */}
                      <Col xs={12} md={4} className="form-col">
                        {/* <Form.Label>Email</Form.Label>
                                            <Form.Control type="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} isInvalid={!!errors.email} />
                                            <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback> */}
                        <TextField
                          label="Email"
                          type="email"
                          value={email}
                          fullWidth
                          onChange={(e) => setEmail(e.target.value)}
                          error={!!errors.email}
                          helperText={errors.email}
                        />
                      </Col>
                      {/* <Col md={4}> */}
                      <Col xs={12} md={4} className="form-col">
                        {/* <Form.Label>Contact Number</Form.Label>
                                            <Form.Control type="text" name="contactNo" value={number} onChange={(e) => setNumber(e.target.value)} isInvalid={!!errors.contactNo} />
                                            <Form.Control.Feedback type="invalid">{errors.contactNo}</Form.Control.Feedback> */}
                        <TextField
                          label="Contact Number"
                          value={number}
                          fullWidth
                          onChange={(e) => setNumber(e.target.value)}
                          error={!!errors.contactNo}
                          helperText={errors.contactNo}
                        />
                      </Col>
                    </Row>
                    {/* <Row className="mt-4">
                                        <Col md={6}>
                                            <Select options={countryOptions} value={myCountry} onChange={(opt) => {
                                                setCountry(opt);
                                                setState([]);
                                                fetchStates(opt.value);
                                            }}
                                                placeholder="--Select Country--" />
                                            {errors.country && <div className="error">{errors.country}</div>}
                                        </Col>
                                        <Col md={6}>
                                            <Select isMulti options={stateOptions} value={state} onChange={setState} isDisabled={!myCountry} placeholder="--Select State--" />
                                            {errors.state && <div className="error">{errors.state}</div>}
                                        </Col>
                                    </Row> */}
                    <Row className="mt-4">
                      {/* <Col md={4}> */}
                      <Col xs={12} md={4} className="form-col">
                        <TextField
                          label="Brand Name"
                          value={brand}
                          fullWidth
                          onChange={(e) => setBrand(e.target.value)}
                          error={!!errors.brand}
                          helperText={errors.brand}
                        />
                      </Col>
                      {/* <Col md={4}> */}
                      <Col xs={12} md={4} className="form-col">
                        <TextField
                          label="Website URL"
                          value={websiteURL}
                          fullWidth
                          onChange={(e) => setWebsiteURL(e.target.value)}
                          error={!!errors.websiteURL}
                          helperText={errors.websiteURL}
                        />
                      </Col>
                      {/* <Col md={4}> */}
                      <Col xs={12} md={4} className="form-col">
                        <TextField
                          label="Location"
                          value={location}
                          fullWidth
                          onChange={(e) => setLocation(e.target.value)}
                          error={!!errors.location}
                          helperText={errors.location}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={6} className="form-col mb-3">
                        <TextField
                          label="Password"
                          type={showPassword ? "text" : "password"}
                          value={password}
                          fullWidth
                          onChange={(e) => setPassword(e.target.value)}
                          error={!!errors.password}
                          helperText={errors.password}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Col>
                      <Col xs={12} md={6} className="form-col mb-3">
                        <TextField
                          label="Confirm Password"
                          type={showConfirmPassword ? "text" : "password"}
                          value={confirmPassword}
                          fullWidth
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          error={!!errors.confirmPassword}
                          helperText={errors.confirmPassword}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle confirm password visibility"
                                  onClick={handleClickShowConfirmPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showConfirmPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Col>
                    </Row>
                    <div className="d-flex flex-column mt-4">
                      <Form.Check
                        type="checkbox"
                        label={
                          <span style={{ fontSize: "14px", color: "#555" }}>
                            I agree to the{" "}
                            <span
                              onClick={() => setModalShow(true)}
                              style={{
                                color: "#007bff",
                                textDecoration: "none",
                                fontWeight: "500",
                                cursor: "pointer",
                              }}
                            >
                              Terms & Conditions{" "}
                            </span>{" "}
                          </span>
                        }
                        checked={agreeToTerms}
                        onChange={handleCheckboxChange}
                        isInvalid={!!errors.agreeToTerms}
                      />
                      {errors.agreeToTerms && (
                        <span
                          style={{
                            color: "red",
                            marginLeft: "6px",
                            fontWeight: "400",
                            fontSize: "13px",
                          }}
                        >
                          {errors.agreeToTerms}
                        </span>
                      )}
                    </div>
                    <Tcmodel
                      show={modalShow}
                      onHide={() => setModalShow(false)}
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "20px",
                      }}
                    >
                      <Button type="submit" disabled={loading}>
                        {loading ? "Signing in..." : "Sign Up"}
                      </Button>
                    </div>
                  </Form>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  signupResponse: state.signup.response,
  signupLoading: state.signup.loading,
  signupError: state.signup.error,
});

const mapDispatchToProps = (dispatch) => ({
  signupAction_: (data) => {
    dispatch(signupAction_(data));
  },
  setUser_: (data) => {
    dispatch(setUser(data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Finalform);
